import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=b7999320&scoped=true&"
import script from "./orderConfirm.vue?vue&type=script&lang=js&"
export * from "./orderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=b7999320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7999320",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {XcoinsStatusDialog: require('/var/jenkins_home/workspace/prod-web-xfans/components/xcoins/StatusDialog.vue').default})
